import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  d: "M3.5 7.5v-3a4 4 0 0 1 8 0v3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  d: "M.5 7.5h14v9a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M10 13h.01v.01H10z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }